import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const EpisodeDetailsIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M3.29275362,0 L14.7072464,0 C15.6144928,0 16.4376812,0.371014493 17.0318841,0.965217391 C17.6289855,1.56231884 18,2.38550725 18,3.29275362 L18,14.7072464 C18,15.6144928 17.6289855,16.4376812 17.0318841,17.0318841 C16.4347826,17.6289855 15.6115942,18 14.7072464,18 L3.29275362,18 C2.38550725,18 1.56231884,17.6289855 0.965217391,17.0318841 C0.371014493,16.4376812 0,15.6144928 0,14.7072464 L0,3.29275362 C0,2.3884058 0.371014493,1.56521739 0.965217391,0.968115942 L0.965217391,0.965217391 C1.56231884,0.371014493 2.38550725,0 3.29275362,0 Z M5.0115942,5.62028986 L12.9884058,5.62028986 C13.3768116,5.62028986 13.6927536,5.30434783 13.6927536,4.91594203 C13.6927536,4.53043478 13.3768116,4.21449275 12.9884058,4.21449275 L5.0115942,4.21449275 C4.62318841,4.21449275 4.30724638,4.53043478 4.30724638,4.91594203 C4.30724638,5.30434783 4.62318841,5.62028986 5.0115942,5.62028986 Z M5.0115942,9.70144928 L9,9.70144928 C9.3884058,9.70144928 9.70144928,9.3884058 9.70144928,9 C9.70144928,8.6115942 9.3884058,8.29855072 9,8.29855072 L5.0115942,8.29855072 C4.62318841,8.29855072 4.30724638,8.6115942 4.30724638,9 C4.30724638,9.3884058 4.62318841,9.70144928 5.0115942,9.70144928 Z M5.0115942,13.7855072 L12.9884058,13.7855072 C13.3768116,13.7855072 13.6927536,13.4695652 13.6927536,13.0811594 C13.6927536,12.6956522 13.3768116,12.3797101 12.9884058,12.3797101 L5.0115942,12.3797101 C4.62318841,12.3797101 4.30724638,12.6956522 4.30724638,13.0811594 C4.30724638,13.4695652 4.62318841,13.7855072 5.0115942,13.7855072 Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

EpisodeDetailsIcon.defaultProps = defaultProps;

export { EpisodeDetailsIcon };
